import React from 'react'
import PropTypes from 'prop-types'
import styles from './LocationAddress.module.scss'
import FormatUtilities from '../../../utilities/FormatUtilities'
import { ReactComponent as Pin } from '../../../assets/media/icons/pin-plus.svg'
import { ReactComponent as Phone } from '../../../assets/media/icons/icon-phone.svg'

const LocationAddress = props => {
    const { firstAddressLine, secondAddressLine } = FormatUtilities.formatAddress(props.address)
    const newLine = firstAddressLine && secondAddressLine
    const phone = props?.phone || undefined
    const isModal = props?.isModal || false

    return (
        <>
            <address>
                <div className={styles.addressContainer}>
                    {(firstAddressLine || secondAddressLine) && (
                        <div className={styles.addressWrapper}>
                            {props?.showIcons && <Pin />}
                            <p className={`${styles.addressText} ${isModal ? styles.addressText_modal : ''}`}>
                                {firstAddressLine}
                                {newLine && <br />}
                                {secondAddressLine}
                            </p>
                        </div>
                    )}
                    {phone && (
                        <div className={styles.phoneWrapper}>
                            {props?.showIcons && <Phone />}
                            <p className={styles.phoneNumber}>{phone}</p>
                        </div>
                    )}
                </div>
            </address>
        </>
    )
}

LocationAddress.propTypes = {
    address: PropTypes.object,
    phone: PropTypes.string,
    showIcons: PropTypes.bool,
    isModal: PropTypes.bool,
}
export default LocationAddress
